<template>
  <div
    class="lottie-preview"
    ref="player"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <span
      @click.stop="starClick(item)"
      class="tem_used_icon"
      :class="{ block: item.is_collect }"
      :title="item.is_collect ? '取消收藏' : '收藏'"
      :style="{
        'background-image': item.is_collect
          ? 'url(/preview/icon/icon_collected.png)'
          : 'url(/preview/icon/icon_collect.png)'
      }"
    ></span>
    <img
      v-if="attributeName == '标准'"
      title="标准"
      class="meal-icon"
      src="/preview/icon/user_meal1.png"
      alt="标准"
    />
    <img
      v-else-if="attributeName == '专业'"
      title="专业"
      class="meal-icon"
      src="/preview/icon/user_meal2.png"
      alt="专业"
    />
    <img
      v-else-if="attributeName == '旗舰'"
      title="旗舰"
      class="meal-icon"
      src="/preview/icon/user_meal3.png"
      alt="旗舰"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import lottie from 'lottie-web';
// import { getEffectContentStyle, clamp } from '../../utils';
import getLottie from '../../utils/getLottie';

export default {
  props: ['lottieId', 'url', 'attributeName', 'item'],
  methods: {
    ...mapActions(['delCollect', 'addCollect']),
    handleMouseEnter() {
      if (this.animation) {
        this.animation.goToAndPlay(0);
      }
    },
    handleMouseLeave() {
      if (this.animation) {
        this.animation.goToAndStop(Math.floor(this.animation.totalFrames / 2), true);
      }
    },
    // 点击收藏
    async starClick(item) {
      if (item.is_collect) {
        // 取消
        await this.delCollect({ type: 'lottie', id: item.id })
        this.$set(item, 'is_collect', false)
      } else {
        // 收藏
        await this.addCollect({ type: 'lottie', id: item.id })
        this.$set(item, 'is_collect', true)
      }
    },
  },
  async mounted() {
    if (!this.url) {
      return;
    }
    const lottieFile = await getLottie(this.url);
    const assetsPath = this.url.replace(/[^/]+$/, '') + 'images/';

    // console.log(lottieFile);

    const animation = lottie.loadAnimation({
      container: this.$refs.player,
      renderer: 'svg',
      autoplay: false,
      name: this.lottieId,
      animationData: lottieFile,
      loop: true,
      rendererSettings: {
        progressiveLoad: true
      },
      assetsPath
    });

    animation.goToAndStop(Math.floor(animation.totalFrames / 2), true);
    this.animation = animation;

    this.observer = new IntersectionObserver(([{ isIntersecting }]) => {
      if (isIntersecting) {
        // console.log('intersecting');
        if (this.removedElement) {
          this.$el.appendChild(this.removedElement);
          this.removedElement = null;
        }
      } else if (!this.removedElement) {
        // console.log('not intersecting');
        if (this.$el.childNodes[0]) {
          this.removedElement = this.$el.removeChild(this.$el.childNodes[0]);
        }
      }
    });
    this.observer.observe(this.$el);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.unobserve(this.$el);
    }
    if (this.removedElement) {
      this.$el.appendChild(this.removedElement);
      this.removedElement = null;
    }
    if (this.animation) {
      this.animation.destroy();
    }
  },
}
</script>
<style scoped>
.lottie-preview:hover .tem_used_icon,
.tem_used_icon.block {
  display: block;
}
.tem_used_icon {
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}
.lottie-preview {
  position: relative;
}
.meal-icon {
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
</style>